import {enhanceAppSelects} from "./select";

type ModalOptions = {
    afterClose?: (response: any, options: ModalOptions) => void;
    beforeShow?: (dialog: HTMLDialogElement, response: any) => void;
    afterShow?: (dialog: HTMLDialogElement, response: any) => void;
    beforeHide?: (dialog: HTMLDialogElement, response: any) => void;
    afterHide?: (dialog: HTMLDialogElement, response: any) => void;
}

export function getCsrfToken(): string {
    return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ''
}

export function getCsrfParam(): string {
    return document.querySelector<HTMLMetaElement>('meta[name="csrf-param"]')?.content ?? ''
}

export function reload() {
    window.location.reload()
}

export function bindShowModal(selector: string, options: ModalOptions) {
    document.querySelectorAll<HTMLAnchorElement>(selector).forEach((link) => {
        link.addEventListener('click', (event) => {
            event.preventDefault()
            fetchModalForm(link.href, options)
        })
    })
}

function processResponse(response: any, options: ModalOptions) {
    if (response.form) {
        showModal(response.form, options, response)
    } else if (response.model) {
        options.afterClose?.(response, options)
    } else if (response.location) {
        window.location.assign(response.location)
    } else {
        showError(new Error('Invalid response'))
    }
}

function fetchModalForm(url: string, options: ModalOptions) {
    fetch(url)
        .then((response) => {
            if (!response.ok) {
                throw response
            }

            return response.json()
        })
        .then((response) => processResponse(response, options))
        .catch(showError)
}

function showError(error: any) {
    if (error.status === 403) {
        alert('Операция запрещена')
    } else {
        alert(error.toString())
    }
}

function showModal(html: string, options: ModalOptions, response: any) {
    const wrapper = document.createElement('div')
    wrapper.innerHTML = html.trim()
    const dialog = wrapper.querySelector<HTMLDialogElement>('dialog')
    if (!dialog) {
        showError(new Error('Modal dialog was not found in the response'))
        return
    }

    document.body.append(wrapper)
    options.beforeShow?.(dialog, response)

    dialog.querySelectorAll<HTMLElement>('[data-dialog-close]').forEach((button) => {
        button.addEventListener('click', () => {
            options.beforeHide?.(dialog, response)
            dialog.close()
        })
    })
    dialog.addEventListener('cancel', () => options.beforeHide?.(dialog, response))
    dialog.addEventListener('click', (event) => {
        if (event.target === dialog) {
            options.beforeHide?.(dialog, response)
            dialog.close()
            return
        }

        if (event.target instanceof Element && event.target.closest('.js-submit')) {
            event.preventDefault()
            submitForm(dialog, options)
        }
    })
    dialog.addEventListener('close', () => {
        wrapper.remove()
        options.afterHide?.(dialog, response)
    }, {once: true})

    dialog.showModal()
    enhanceAppSelects(dialog)
    options.afterShow?.(dialog, response)
}

function submitForm(dialog: HTMLDialogElement, options: ModalOptions) {
    const form = dialog.querySelector<HTMLFormElement>('form')
    if (!form) {
        showError(new Error('Form was not found in the dialog'))
        return
    }

    const body = new URLSearchParams(new FormData(form) as any)
    fetch(form.action, {method: form.method, body})
        .then((response) => {
            if (!response.ok) {
                throw response
            }

            return response.json()
        })
        .then((response) => {
            if (response.form) {
                dialog.close()
            }
            processResponse(response, options)
        })
        .catch(showError)
        .finally(() => {
            if (dialog.open) {
                dialog.close()
            }
        })
}
